// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + ({"125":"component---src-pages-404-js","293":"component---src-pages-index-js"}[chunkId] || chunkId) + "-" + {"125":"3d7d84558445239b54c1","293":"60ae867cb6ffe1e489ab","935":"640ebf6187ef36d6cfd3"}[chunkId] + ".js";
};